import { AutodataTrackingTypes } from "./ts/types";

import { isElementOpened } from "../../collapsible/src/helpers";
import { getDataEvent } from "../../autodata/src/helpers";
import { CSSClassnames } from "../../collapsible/src/ts/enum";

export const elementHasBeenOpened = ({ oldValue, target }: MutationRecord) => {
  if (!(oldValue !== null && oldValue.includes(CSSClassnames.OPENED))) {
    return isElementOpened(target as HTMLElement);
  }

  return false;
};

const addMutationObserver = (
  button: HTMLElement,
  autoData: AutoData
): MutationObserver => {
  const buttonObserver: MutationObserver = new MutationObserver(
    mutationsList => {
      const [buttonMutation] = mutationsList;
      const type = button.getAttribute("data-event-type");
      const hasBeenOpened = elementHasBeenOpened(buttonMutation);

      const dataEvent = getDataEvent(
        button,
        AutodataTrackingTypes.collapsible,
        {
          action: { type, hasBeenOpened },
        }
      );

      // No need event when user close contact collapsible block
      if (type === "category" || (type === "contact" && hasBeenOpened)) {
        autoData.sendEvent(dataEvent);
      }
    }
  );

  buttonObserver.observe(button, {
    attributeOldValue: true,
    attributeFilter: ["class"],
  });

  return buttonObserver;
};

export default (domElements: HTMLElement[], autoData: AutoData) => {
  const disposableObservers = Array.from(domElements).reduce(
    (observers: MutationObserver[], domElement) => {
      return [...observers, addMutationObserver(domElement, autoData)];
    },
    []
  );

  return function disposableCallback() {
    disposableObservers.forEach(disposableObserver => {
      disposableObserver.disconnect();
    });
  };
};
